import { render, staticRenderFns } from "./accountVerification.vue?vue&type=template&id=21f60846&"
import script from "./accountVerification.vue?vue&type=script&lang=js&"
export * from "./accountVerification.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports